import { render } from "./EditShiftModal.vue?vue&type=template&id=0257aa7a&scoped=true"
import script from "./EditShiftModal.vue?vue&type=script&lang=js"
export * from "./EditShiftModal.vue?vue&type=script&lang=js"

import "./EditShiftModal.vue?vue&type=style&index=0&id=0257aa7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0257aa7a"]])

export default __exports__